import Api from './Api';
import Configuracao from '../util/Configuracao';

class FaixaRemuneracaoApi extends Api {
  async consultarFaixas (valor) {
    try {
      const faixasUrl = Configuracao.getConfiguracao().urlConsultarFaixasRemuneracao + valor;
      const response = await this.fetch(faixasUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirFaixa (faixa) {
    try {
      const urlIncluirFaixa = Configuracao.getConfiguracao().urlIncluirFaixaRemuneracao;
      const response = await this.fetch(urlIncluirFaixa, 'put', faixa);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirFaixa (seqRemuneracao) {
    try {
      const urlExcluirFaixa = Configuracao.getConfiguracao().urlExcluirFaixaRemuneracao + '/' + seqRemuneracao;
      const response = await this.fetch(urlExcluirFaixa, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarFaixa (faixa) {
    try {
      const urlAlterarFaixa = Configuracao.getConfiguracao().urlAlterarFaixaRemuneracao;
      const response = await this.fetch(urlAlterarFaixa, 'put', faixa);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async validarFaixa (faixa, indInclusao) {
    try {
      const urlValidarFaixaRemuneracao = Configuracao.getConfiguracao().urlValidarFaixaRemuneracao + indInclusao;
      const result = await this.fetch(urlValidarFaixaRemuneracao, 'post', faixa);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
}
export default FaixaRemuneracaoApi;
